<template>
    <router-link to="/project/single" :class="'project '+className">
        <div class="project-inner">
            <div v-if="item.img" class="project-img">
                <img :src="item.img" alt="Project"/>
            </div>
            <div v-if="item.description || item.title" class="project-content">
                <h4 v-if="item.title">{{ item.title }}</h4>
                <p v-if="item.description">{{ item.description }}</p>
            </div>

            <i :class="'right-arrow las '+ iconName"></i>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'ProjectItem',
    props: {
        item: {
            type: Object,
        },
        className: {
            type: String
        },
        iconName: {
            type: String,
            default: 'la-angle-right'
        }
    }
}
</script>